import {UTCDate} from "@date-fns/utc";
import {parseISO} from "date-fns";
import {FiCalendar} from "react-icons/fi";

import {TwoLineShortDateTimeUser} from "@/components/datetime/TwoLineShortDateTimeUser.tsx";
import {dateStringWithTimezone, timeStringWithTimezone} from "@/components/datetime/utils.ts";
import {Dot} from "@/components/dot/Dot.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {formatDateTime} from "@/lib/format.tsx";
import {AccountUser} from "@/lib/types/accounts.ts";

interface IncidentEndDateProps {
  endsAt: string | null;
  startsAt?: string;
  user: AccountUser;
}

export const IncidentEndDate = ({endsAt, user, startsAt}: IncidentEndDateProps) => {
  const endsAtDate = endsAt ? parseISO(endsAt) : null;
  const isActive =
    endsAt === null || (parseISO(endsAt) > new UTCDate() && (startsAt ? parseISO(startsAt) <= new UTCDate() : true));

  return (
    <>
      {isActive && (
        <span className="d-flex align-items-center gap-1">
          <Dot variant={"red"} /> Active
        </span>
      )}
      {endsAtDate && !isActive && <TwoLineShortDateTimeUser date={endsAt.toString()} user={user} />}
      {endsAtDate && isActive && (
        <Tooltip
          tooltipContent={
            <>
              Scheduled end: {dateStringWithTimezone(endsAtDate, user.account.timezone, user!.current_date_format)},
              <br />
              {timeStringWithTimezone(endsAtDate, user.account.timezone, user!.current_time_format)}
            </>
          }
          delayMs={500}
        >
          <span className="d-flex align-items-center">
            <Icon icon={FiCalendar} className="pulse-color-gray-600" />
            <div className="pulse-color-gray-600 fst-italic ellipsis-overflow">
              {formatDateTime(endsAtDate, user.account.timezone, user.current_date_format, user.current_time_format)}
            </div>
          </span>
        </Tooltip>
      )}
    </>
  );
};
